import { Injectable } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';

@Injectable()
export class ProductAddForm {
    constructor(private formBuilder: FormBuilder) {}

    public buildForm(): FormGroup {
        return this.formBuilder.group({
            campaignUuid: [null, [Validators.required]],
            name: ['', [Validators.required]],
            externalId: [null],
            category: ['', Validators.required],
            subcategory: [null],
            products: [[]],
        });
    }
}
